export const toSearchParams = (obj: Record<string, any>): URLSearchParams => {
    const searchParams = new URLSearchParams();
    Object.entries(obj).forEach(([key, value]) => {
        if (!value) return;
        if (value instanceof Array) {
            value.forEach((v) => searchParams.append(key, v));
        } else if (value instanceof Object) {
            searchParams.append(key, JSON.stringify(value));
        } else {
            searchParams.append(key, value);
        }
    });
    return searchParams;
};
